import './App.less'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { AliveScope } from 'react-activation'
import AuthRoute from './components/AuthRoute'
import Login from './views/Login'
import MainLayout from './components/MainLayout'
import { connect } from 'react-redux'
import 'moment/locale/zh-cn'

const App = (props) => {
  //弹出框跟随滚动
  const getPopupContainer = (triggerNode) => {
    if (triggerNode) return triggerNode.parentNode
    return document.body
  }
  return (
    <ConfigProvider locale={zhCN} getPopupContainer={getPopupContainer}>
      <AliveScope>
        <Router>
          <Switch>
            <Route component={Login} path="/login" />
            <AuthRoute component={MainLayout} />
          </Switch>
        </Router>
      </AliveScope>
    </ConfigProvider>
  )
}
export default connect((state) => {
  return { auth: state.auth }
})(App)
